import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _byMediaType = {
    quotas: '_quotaByMediaType',
    usage: '_usageByMediaType',
};
var _getByMediaTypeRequest = {};
var _getByMediaTypeResponse = { byMediaType: '_byMediaType' };
var _getTotalRequest = {};
var _getTotalResponse = { total: '_total' };
var _plan = {
    createdAt: 'google.protobuf.Timestamp',
    expiresAt: 'google.protobuf.Timestamp',
};
var _plans = { premium: '_plan' };
var _purgeSiteCacheRequest = {};
var _purgeSiteCacheResponse = {};
var _quotaByMediaType = {
    timestamp: 'google.protobuf.Timestamp',
    plans: '_plans',
};
var _total = { quota: '_totalQuota', usage: '_totalUsage' };
var _totalQuota = { timestamp: 'google.protobuf.Timestamp', plans: '_plans' };
var _totalUsage = { lastProcessed: 'google.protobuf.Timestamp' };
var _usageByMediaType = { lastProcessed: 'google.protobuf.Timestamp' };
function resolveWixMediaQuotaV1MediaQuotaServiceUrl(opts) {
    var domainToMappings = {
        'manage._base_domain_': [
            {
                srcPath: '/_api/media-quota-server',
                destPath: '',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/** Get total storage usage of a site */
export function getTotal(payload) {
    var _a = serializer(_getTotalRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getTotalResponse, {
        _plan: _plan,
        _plans: _plans,
        _total: _total,
        _totalQuota: _totalQuota,
        _totalUsage: _totalUsage,
    }).fromJSON;
    function __getTotal(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.media.quota.v1.total',
            method: 'GET',
            methodFqn: 'wix.media.quota.v1.MediaQuotaService.GetTotal',
            url: resolveWixMediaQuotaV1MediaQuotaServiceUrl({
                protoPath: '/v1/total',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getTotal.fromReq = fromReq;
    return __getTotal;
}
/** Get storage usage of a site, grouped by media type */
export function getByMediaType(payload) {
    var _a = serializer(_getByMediaTypeRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getByMediaTypeResponse, {
        _byMediaType: _byMediaType,
        _plan: _plan,
        _plans: _plans,
        _quotaByMediaType: _quotaByMediaType,
        _usageByMediaType: _usageByMediaType,
    }).fromJSON;
    function __getByMediaType(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.media.quota.v1.total',
            method: 'GET',
            methodFqn: 'wix.media.quota.v1.MediaQuotaService.GetByMediaType',
            url: resolveWixMediaQuotaV1MediaQuotaServiceUrl({
                protoPath: '/v1/by-media-type',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getByMediaType.fromReq = fromReq;
    return __getByMediaType;
}
export function purgeSiteCache(payload) {
    var _a = serializer(_purgeSiteCacheRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_purgeSiteCacheResponse, {}).fromJSON;
    function __purgeSiteCache(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.media.quota.v1.total',
            method: 'POST',
            methodFqn: 'wix.media.quota.v1.MediaQuotaService.PurgeSiteCache',
            url: resolveWixMediaQuotaV1MediaQuotaServiceUrl({
                protoPath: '/v1/purge-site-cache',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __purgeSiteCache.fromReq = fromReq;
    return __purgeSiteCache;
}
//# sourceMappingURL=http.impl.js.map